/**
 * @generated SignedSource<<031a6192048e9d1b593c4821277902d2>>
 * @relayHash 48883c3430b337df85efc3c7b6fa0069
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e6a57d4ef14457ed8ec9a6086da502fa5a2213a8e3a67372b7b67bc04501e6ba

import type { ConcreteRequest, Query } from 'relay-runtime';
export type displaySettingsProviderQuery$variables = {
  entityAri: string;
  ownerAri: string;
};
export type displaySettingsProviderQuery$data = {
  readonly settings_navigationCustomisation: {
    readonly id: string;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly key: string | null | undefined;
        readonly value: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type displaySettingsProviderQuery = {
  response: displaySettingsProviderQuery$data;
  variables: displaySettingsProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ownerAri"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "entityAri",
        "variableName": "entityAri"
      },
      {
        "kind": "Variable",
        "name": "ownerAri",
        "variableName": "ownerAri"
      }
    ],
    "concreteType": "SettingsNavigationCustomisation",
    "kind": "LinkedField",
    "name": "settings_navigationCustomisation",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "SettingsDisplayPropertyConnection",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
          {
            "concreteType": "SettingsDisplayProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "value"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "displaySettingsProviderQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "displaySettingsProviderQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "e6a57d4ef14457ed8ec9a6086da502fa5a2213a8e3a67372b7b67bc04501e6ba",
    "metadata": {},
    "name": "displaySettingsProviderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d5c1b181a57d74905155f0575dcb7b88";

export default node;
